import React, { Component } from 'react';
import joinus from './images/joinus.png';
class JoinUs extends Component {
  componentDidMount(){
    window.scrollTo(0,0);
  }

  render() {
    return (
      <div className="joinUs">
         <div className='joinus-banner'>
           <div><img className='joinus-img' src={joinus} alt='加入我们' width='753' height='277' /></div>
           <p style={{fontSize:22}}>wenyanna@56xyl.com</p>
        </div>
        <div className='joinus-content'>
            <div className='max-width-box'>
                <div className='joinus-top'>
                    <div className='joinus-title'>
                        <h3>我们期待您的加入</h3>
                       <span className='line'></span>
                    </div>
                    <p className='company-brief'>公司成立于2021年，坐落于美丽的羊城——广州，是一家专注于企业级软件开发的创业型科技公司。
我们崇尚专注热爱的事业，更加尊重自由奔放的个性。在这里，我们以一种体现自我价值的态度生存。
我们以80/90后为主，是一个有创意、有朝气的互联网企业。</p>
                    <div className='company-welfare'>
                        <div className='welfare-item'>
                          <h3>做五休二</h3>
                          <p>周末自由安排</p>
                        </div>
                        <div className='welfare-item'>
                          <h3>五险一金</h3>
                          <p>享有社会保障</p>
                        </div>
                        <div className='welfare-item'>
                          <h3>定期体检</h3>
                          <p>每年集体体检</p>
                        </div>
                        <div className='welfare-item'>
                          <h3>带薪年假</h3>
                          <p>入职满一年享有</p>
                        </div>
                    </div>
                    <div className='joinus-title'>
                        <h3>招聘职位</h3>
                       <span className='line'></span>
                    </div>
                    <div className='job-type'>
                      <h2 className='job-name'>产品经理</h2>
                      <div className='job-item'>
                        <h4>工作职责</h4>
                        <p>1. 负责公司产品的规划，设计和管理；</p>
                        <p>2. 分析移动互联网产业发展的热点和趋势，前期产品市场需求调研，产品创意和可行性分析，同类产品市场资料的收集；</p>
                        <p>3. 充分了解用户需求，收集用户反馈，分析用户行为及需求，对产品进行持续的优化和改进；</p>
                        <p>4. 根据产品需求，撰写详细的产品设计文档和原型设计文档；</p>
                        <p>5. 引导完成产品的界面、功能、流程设计，协调开发人员进行开发工作，推动及协调产品的开发进度，把控项目质量</p>
                      </div>
                      <div className='job-item'>
                        <h4>岗位要求</h4>
                        <p>1. 3年以上移动互联网相关产品规划和运营的工作经验，对产品有深刻理解，有成功案例；</p>
                        <p>2. 出色的表达能力，文档写作能力和产品原型表现能力；能够熟练使用产品原型搭建工具；</p>
                        <p>3. 具备良好的数据与竞争对手分析能力，较好的逻辑思维与分析能力，能够对自有产品提出整改计划；</p>
                        <p>4. 对于用户体验有深刻的理解，能够很好的规划和设计产品功能、使用流程与交互体验；</p>
                        <p>5. 善于总结和归纳用户的体验度模型，有很强的感性认知能力和理性分析能力；</p>
                        <p>6. 在电商、物流领域有丰富经验者，从事过货代、船代、车联网产品策划者优先考虑。</p>
                      </div>
                    </div>
                    <div className='job-type'>
                      <h2 className='job-name'>运维工程师</h2>
                      <div className='job-item'>
                        <h4>工作职责</h4>
                        <p>1. 全面负责公司运维项目的系统升级、扩容需求与资源落实，配合开发需求，测试、调整运维平台；</p>
                        <p>2. 负责网络以及服务器的网络设置、维护和优化、网络的安全监控、系统性能管理和优化、网络性能管理和优化；</p>
                        <p>3. 负责IT运维相关流程的规划、设计、推行、实施和持续改进；</p>
                        <p>4. 负责配合开发搭建测试平台，协助开发设计、推行、实施和持续改进;</p>
                        <p>5. 负责相关故障、疑难问题排查处理，编制汇总故障、问题，定期提交汇总报告;</p>
                        <p>6. 负责网络监控和应急反应，以确保网络系统有7*24小时的持续运作能力;</p>
                        <p>7. 保障服务器与数据库安全，检查并消除安全漏洞；</p>
                        <p>8. 数据备份、数据监控、应急响应、故障排除、编写数据分析报告等；</p>
                        <p>9. 负责日常系统维护，及监控，提供IT软硬件方面的服务和支持，保证系统的稳定。</p>
                      </div>
                      <div className='job-item'>
                        <h4>岗位要求</h4>
                        <p>1. 2年以上大中型在线系统运维工作经验、精通Linux系统及常见服务的安装配置，熟悉常见的负载均衡实现方案并有实际实施经验；</p>
                        <p>2. 精通Linux系统如Redhat、CentOS、精通Apache、NginX、MySQL、tomcat、CDN、memc-ached等常用服务的安装、配置和维护；</p>
                        <p>3. 精通和灵活运用1种以上的脚本语言，包括：Shell、PERL、Python等；</p>
                        <p>4. 熟悉TCP/IP协议，能够熟练排查运维过程中出现的服务故障、系统故障、网络故障；</p>
                        <p>5. 精通MySQL数据库管理、维护，熟练掌握MySQL主从复制、读写分离、高可用集群架构的安装、配置和管理；</p>
                        <p>6. 熟练掌握Redis、 CouchDB等NoSQL的安装、配置和管理；</p>
                        <p>7.通系统监控工具Zabbix、Nagois、Cacti等其中之一，数量使用Ansible、Salt-stack等集中化配置管理工具；</p>
                        <p>8. 熟悉日志集中化管理平台ELK Stack的安装、管理于与维护；</p>
                        <p>9. 高度的责任感，较强的故障分析及排除能力，善于在工作中学习，能够承受工作压力；</p>
                      </div>
                    </div>
                    <div className='job-type'>
                      <h2 className='job-name'>JAVA中级工程师</h2>
                      <div className='job-item'>
                        <h4>工作职责</h4>
                        <p>1. 根据分配的开发任务，按时高质量地完成代码的开发；</p>
                        <p>2. 分析、调试并解决开发过程中发现的问题；</p>
                        <p>3. 完成上级交办的其它工作；</p>
                      </div>
                      <div className='job-item'>
                        <h4>岗位要求</h4>
                        <p>1. 熟悉JAVA WEB开发技术（JAVA、JSP、JDBC、Servlet,Spring、MyBatics、Hibernate等）； </p>
                        <p>2. 精通WEB前端技术：HTML(5)、CSS、JavaScript、Json、AJAX；熟练使用JQuery等主流JS、CSS前端框架； </p>
                        <p>3. 熟悉常见的应用系统架构和软件研发流程；熟练使用NetBeans,Eclipse（Myeclipse）、IntelliJ、SVN； </p>
                        <p>4. 有大规模 Web 应用开发及电子商务经验优先</p>
                        <p>5. 熟悉Tomcat、GlassFish、WebLogic至少一种应用服务器配置及优化； </p>
                        <p>6. 做事细心，具备良好的沟通表达能力和团队合作精神；人品正直诚实，有责任心，能够承受一定的工作压力。 </p>
                        <p>7. 二至三年以上web应用开发工作经验,计算机软件、数学相关专业.</p>
                      </div>
                    </div>
                    <div className='job-type'>
                      <h2 className='job-name'>前端高级工程师</h2>
                      <div className='job-item'>
                        <h4>工作职责</h4>
                        <p>1. 负责前端框架把控，制定相关规范标准；负责攻克前端技术难点，把控前端代码质量；</p>
                        <p>2. 实现产品所需的动画及交互效果；与产品经理，UI合作，完善产品交互功能；</p>
                        <p>3. 新技术预研及培训分享。 </p>
                      </div>
                      <div className='job-item'>
                        <h4>岗位要求</h4>
                        <p>1. 4年以上Web前端开发；</p>
                        <p>2. 精通Javascript、JQuery、HTML5、CSS3， </p>
                        <p>3. 深刻理解Web标准及各主流浏览器间的兼容性，能快速定位、解决开发中遇到的浏览器兼容性问题； </p>
                        <p>4. 熟悉MVC/MVVM开发模式，熟练使用JQuery/Zepto/Bootstrap/Easyui/Requirejs/React等框架；</p>
                        <p>5. 熟悉前端编译和构建工具，熟练运用gulp、grunt、webpack等工具；</p>
                        <p>6. 有Java等后台开发经验优先； </p>
                        <p>7. 注重细节，追求完美。</p>
                      </div>
                    </div>
                    <div className='expected'>最新职位，敬请期待！</div>
                </div>
            </div>
        </div>
      </div>
    );
  }
}

export default JoinUs;



// WEBPACK FOOTER //
// ./src/pages/joinUs/index.js